import script from "./PasscodeVerify.vue?vue&type=script&setup=true&lang=js"
export * from "./PasscodeVerify.vue?vue&type=script&setup=true&lang=js"

import "./PasscodeVerify.vue?vue&type=style&index=0&id=06f185de&lang=scss&scoped=true"

import exportComponent from "/data/jenkins/workspace/akc-mallrobot-akc-dz-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06f185de"]])

export default __exports__